module.exports = __webpack_public_path__ + "static/media/off.5b336403.svg";